import React from 'react';
// Redux
import { useDispatch } from 'react-redux';
import { TaxFilters } from '../../../redux/types/filtersTypes';
import { setFilters, resetFilters } from '../../../redux/actions/FiltersActions';
// App
import DashboardComponent from '../../../components/DashboardComponent';
import TaxListComponent from '../../../components/Taxes/TaxListComponent';
// Other
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

export default function TaxesRouting(props: RouteComponentProps) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setFilters(new TaxFilters()));
    return () => {
      dispatch(resetFilters());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardComponent
      title={<h2>Impuestos</h2>}
      children={<Switch>
        <Route exact path={props.match.path + '/list'} component={TaxListComponent} />
        <Redirect to={props.match.path + '/list'} />
      </Switch>}
    />
  );
}